import React from 'react';
import { Trash2 } from 'react-feather';
import { renderDynamicField } from './DynamicForm.form.fields';
import type {
  FormFieldValue,
  RepeatableAIContext,
  RepeatableBlock,
  RepeatableTemplate,
} from './DynamicForm.repeatable.utils';
import { fieldsForInstance } from './DynamicForm.repeatable.utils';
import {
  SectionDivider,
  RepeatableBlockHeader,
  RepeatableBlockTitle,
  RepeatableDeleteButton,
} from './DynamicForm.styles.index';

export type RepeatableFormBlockProps = {
  template: RepeatableTemplate;
  index: number;
  block: RepeatableBlock;
  fieldErrors: Record<string, string>;
  onChange: (fieldName: string, value: FormFieldValue) => void;
  onDelete?: () => void;
  aiContext: RepeatableAIContext;
};

export function RepeatableFormBlock({
  template,
  index,
  block,
  fieldErrors,
  onChange,
  onDelete,
  aiContext,
}: RepeatableFormBlockProps): React.JSX.Element {
  const fields = fieldsForInstance(template, index);

  return (
    <div>
      <RepeatableBlockHeader>
        <RepeatableBlockTitle>{`${template.sectionTitle} ${index + 1}`}</RepeatableBlockTitle>
        {onDelete && (
          <RepeatableDeleteButton type="button" onClick={onDelete}>
            <Trash2 size={14} />
            Delete
          </RepeatableDeleteButton>
        )}
      </RepeatableBlockHeader>
      <SectionDivider />
      {fields.map((field, fieldIndex) => {
        const baseField = template.baseFields[fieldIndex];
        if (!baseField) {
          return null;
        }
        const value = block[baseField.name];
        const handleChange = (_fieldName: string, newValue: FormFieldValue): void => {
          onChange(baseField.name, newValue);
        };
        return renderDynamicField(
          field,
          value,
          handleChange,
          false,
          fieldErrors[field.name],
          aiContext.aiState,
          aiContext.onAICorrection,
          aiContext.correctionsApplied,
          aiContext.animationPhase,
          true
        );
      })}
    </div>
  );
}
